module.exports = __webpack_public_path__ + "img/person1.bd096794.jpg";